import _defineProperty from "/var/www/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/var/www/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["href", "params", "query", "passHref", "prefetch"],
  _excluded2 = ["href", "activeClassName", "className", "innerRef", "naked", "prefetch"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable no-restricted-syntax */
/* eslint-disable guard-for-in */
import * as React from 'react';
import { useRouter } from 'next/router';
// import NextLink from 'next/link';
import { Link as MuiLink } from '@mui/material';
import { Link as NextLink } from '@app/config/i18n';
var _require = require('../../../server/routes'),
  routes = _require.routes;

/**
 * This function is used to replace Link params with the params object
 * @param {*} route
 * @param {*} params
 * @returns
 */
var parseRouteUrl = function parseRouteUrl(route, params) {
  for (var key in params) {
    var regex = new RegExp(":".concat(key), 'g');
    route = route.replace(regex, params[key]);
  }
  return route;
};
var NextComposed = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var href = props.href,
    _props$params = props.params,
    params = _props$params === void 0 ? {} : _props$params,
    _props$query = props.query,
    query = _props$query === void 0 ? {} : _props$query,
    passHref = props.passHref,
    prefetch = props.prefetch,
    other = _objectWithoutProperties(props, _excluded);
  var component = href;
  var url;
  if (href && Object.prototype.hasOwnProperty.call(routes, href)) {
    var qs = new URLSearchParams(_objectSpread(_objectSpread({}, params), query)).toString();
    component = routes[href].component;
    component += qs ? "?".concat(qs) : '';
    url = parseRouteUrl(routes[href].url, params);
    qs = new URLSearchParams(query).toString();
    url += qs ? "?".concat(qs) : '';
    return /*#__PURE__*/React.createElement(NextLink, {
      href: component,
      passHref: passHref,
      as: url
    }, /*#__PURE__*/React.createElement('a', _objectSpread({
      ref: ref
    }, other)));
  }
  return /*#__PURE__*/React.createElement('a', _objectSpread({
    href: component,
    ref: ref
  }, other));
});
NextComposed.displayName = 'NextComposed';
NextComposed.defaultProps = {
  params: {},
  query: {},
  prefetch: true
};

// A styled version of the Next.js Link component:
// https://nextjs.org/docs/#with-link
function Link(_ref) {
  var _ref$href = _ref.href,
    href = _ref$href === void 0 ? '#' : _ref$href,
    activeClassName = _ref.activeClassName,
    classNameProps = _ref.className,
    innerRef = _ref.innerRef,
    naked = _ref.naked,
    prefetch = _ref.prefetch,
    other = _objectWithoutProperties(_ref, _excluded2);
  var router = useRouter();
  var pathname = typeof href === 'string' ? href : href.pathname;
  var component = routes[pathname] ? routes[pathname].component : null;
  var className = router.pathname === component && activeClassName ? activeClassName : '';
  if (naked) {
    return /*#__PURE__*/React.createElement(NextComposed, _objectSpread({
      className: "".concat(className, " ").concat(classNameProps),
      ref: innerRef,
      href: href
    }, other));
  }
  return /*#__PURE__*/React.createElement(MuiLink, _objectSpread({
    component: NextComposed,
    className: "".concat(className, " ").concat(classNameProps),
    ref: innerRef,
    href: href,
    prefetch: prefetch
  }, other));
}
Link.displayName = 'Link';
Link.defaultProps = {
  activeClassName: 'active',
  params: {},
  query: {},
  className: undefined,
  innerRef: undefined,
  naked: false,
  onClick: function onClick() {},
  prefetch: true
};
var ForwardedLink = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Link, _objectSpread(_objectSpread({}, props), {}, {
    innerRef: ref
  }));
});
ForwardedLink.displayName = 'ForwardedLink';
export default ForwardedLink;